import { cloneDeep } from "lodash";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { treeActions } from "../../../redux/slices/treeSlice";
import { getUpdatedData } from "./NewRecordOutbound";
import { getUpdatedData as updateData } from "./NewGetData";
import { RECORD_TYPE, DATA_TYPE } from "../../../constants/datatypes";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { genKey, getUniqueWorkflowItemIdFromArray } from "../../../utils/utilFunctions";
import { t } from "i18next";

const NewVariable = ({ toggle, openModal }) => {
    const { t } = useTranslation();
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
    const currentTab = rightTree.currentTab;
    const selectedNode = rightTree.tree[currentTab].selectedNode;
    const templateHeader = rightTree.tree.templateHeader;
    const [showModal, setShowModal] = useState(false);
    const content = t('BOX_LIKE_TO_PLACE_ITEM_INSIDE_CURR_REC_OR_DIRECTLY_AFTER').split(`\\n`).map((str, idx) => <div key={idx}>{str ? str : <br />}</div>);
    const dispatch = useDispatch();
    const contentRef = useRef();
    const handleNewField = (isInside) => {
        let nestedLevels = selectedNode?.key?.split("-");
        nestedLevels = nestedLevels.splice(1);
        const translatedData = cloneDeep(rightTree.tree[currentTab].translatedData);
        let initialId = translatedData?.[0]?.ID;
        const newId = getUniqueWorkflowItemIdFromArray(translatedData);
        // Function For Getting New Record Title and Key
        const getNewFieldData = (data, key) => {
            //If it is empty so it will make first node with 'ib-0' key
            if (!data.length) return { key: `${key}-0`, title: `${t('UNNAMED')}1`, insertingPosition: 1 };

            let latestNewNodeNum = 0;
            let insertingPosition = 1;
            data.forEach((ele, idx) => {
                // Checking if Unnamed is present already for creating next unnamed record
                const fieldTitle = ele?.MAPNAME;
                if (fieldTitle && fieldTitle.startsWith(`${t("VARUNNAMED")}`)) {
                    const latestUnnamedRecord = Number(fieldTitle.slice(t("VARUNNAMED").length));
                    if (!isNaN(latestUnnamedRecord) && DATA_TYPE[templateHeader?.FILETYPE]?.field?.icon === ele?.ICON_DISPLAY) {
                        latestNewNodeNum =
                            latestUnnamedRecord > latestNewNodeNum
                                ? latestUnnamedRecord
                                : latestNewNodeNum;
                    }
                }
                if (ele.key === selectedNode.key) {
                    insertingPosition = idx + 2;
                }
            });

            const lastRecordKey = data[data.length - 1].key.split("-");
            lastRecordKey[lastRecordKey.length - 1] = +lastRecordKey[lastRecordKey.length - 1] + 1;
            const newRecordKey = lastRecordKey.join("-");
            return {
                key: newRecordKey,
                title: `${t('VARUNNAMED')}${latestNewNodeNum ? +latestNewNodeNum + 1 : 1}`,
                insertingPosition,
            };
        };

        // Inserting New Node Object in Tree Data (Recursive Function);
        function insertNodeInNestedTree(translatedData, nestedLevels, isInside) {
            const level = isInside ? 0 : 1;
            const name = getVariableName(rightTree.tree);
            if (nestedLevels.length === level) {
                const { children = [], key } = translatedData;
                const newFieldDetails = children
                    ? getNewFieldData(children, key)
                    : getNewFieldData(translatedData, parentScreen === "outbound" ? "ob" : "wf");


                const newNode = {

                    VARIABLE: [
                        {
                            "ACTION": "SET",
                            "FIELDTYPE": "ALPHA",
                            "FILLCHAR": " ",
                            "LENGTH": "0",
                            "NAME": parentScreen === "workflow" ? name : t("VARUNNAMED"),
                            "PADDIR": "RIGHT"
                        }
                    ],
                    children: [],
                    key: newFieldDetails.key,
                    nodeId: genKey(newFieldDetails.title),
                    alternateNodeId: genKey(newFieldDetails.title),
                    ...(parentScreen === "workflow" ? {
                        "ACTION": "VARIABLE_ITEM",
                        "ICON_DISPLAY": "VARIABLE_ITEM",
                        "title": name,
                        "CONCURRENT": "FALSE",
                        "ID": newId,
                        "LOG_WFITEM_DETAILS": "TRUE",
                        "NAME": name,
                    } : {
                        "DESCRIPTION": "",
                        "TYPE": "VARIABLE",
                        "NAME": `${t("VARUNNAMED")}`,
                        "title": `${t("VARIABLE_")} ${t("VARUNNAMED")}`,
                        "ICON_DISPLAY": "VARIABLE",
                    }),
                }

                dispatch(treeActions.setRightTreeSelectedNode({
                    screen: parentScreen,
                    type: currentTab,
                    data: {}
                }));
                if (children) {
                    if (isInside) {
                        translatedData.children.splice(0, 0, newNode);
                        let newKey = selectedNode.key.split('-');
                        newKey.push('0')
                        newKey = newKey.join('-');
                        setTimeout(() => {
                            dispatch(treeActions.setRightTreeSelectedNode({
                                screen: parentScreen,
                                type: currentTab,
                                data: { ...newNode, key: newKey }
                            }));
                        })
                    } else {
                        const tempKey = selectedNode?.key?.split('-');
                        const lastIndex = + tempKey[tempKey.length - 1] + 1

                        if (selectedNode?.ICON_DISPLAY === 'CONDITION_IF' && translatedData?.children[lastIndex]?.ICON_DISPLAY === "CONDITION_ELSE") {
                            translatedData.children.splice(lastIndex + 1, 0, newNode);
                            let newKey = selectedNode.key.split('-');
                            newKey[newKey.length - 1] = Number(newKey[newKey.length - 1]) + 2;
                            newKey = newKey.join('-');
                            //  newNode.RECORD_TYPE = selectedNode?.RECORD_TYPE;
                            setTimeout(() => {
                                dispatch(treeActions.setRightTreeSelectedNode({
                                    screen: parentScreen,
                                    type: currentTab,
                                    data: { ...newNode, key: newKey }
                                }));
                            })
                        }
                        else {
                            translatedData.children.splice(newFieldDetails.insertingPosition - 1, 0, newNode);
                            let newKey = selectedNode.key.split('-');
                            newKey[newKey.length - 1] = Number(newKey[newKey.length - 1]) + 1;
                            newKey = newKey.join('-');
                            //  newNode.RECORD_TYPE = selectedNode?.RECORD_TYPE;
                            setTimeout(() => {
                                dispatch(treeActions.setRightTreeSelectedNode({
                                    screen: parentScreen,
                                    type: currentTab,
                                    data: { ...newNode, key: newKey }
                                }));
                            })
                        }


                    }
                }
                return;
            }

            const isArray = Array.isArray(translatedData);
            if (isArray) {
                const nestedData = translatedData[[nestedLevels[0]]];
                const newNestedLevels = nestedLevels.splice(1);
                insertNodeInNestedTree(nestedData, newNestedLevels, isInside);
            } else {
                // const newNestedLevels = nestedLevels.splice(1);
                insertNodeInNestedTree(translatedData.children, nestedLevels, isInside);
            }
        }

        insertNodeInNestedTree(translatedData, nestedLevels, isInside);
        const updatedData = parentScreen === "outbound" ? getUpdatedData(translatedData, templateHeader?.FILETYPE, null, parentScreen === 'workflow', currentTab) : updateData(translatedData);
        dispatch(
            treeActions.setNewRightTreeTranslatedData({
                screen: parentScreen,
                type: currentTab,
                data: updatedData,
            })
        );
        toggle(null);
        setShowModal(false);
    };

    const newVariableHandler = () => {
        if (selectedNode?.key?.split("-").length === 2) {
            handleNewField(true)
        }
        else if (selectedNode?.ICON_DISPLAY === "QUERY" && parentScreen === "outbound") {
            handleNewField(false)
        }
        else if (["CONDITION_IF", "CONDITION_ELSE", "FIELD_GROUP", "REPEATING_FIELD_GROUP"].includes(selectedNode.ICON_DISPLAY) && openModal && parentScreen === "outbound") {
            setShowModal(true);
        }
        else if (!RECORD_TYPE[selectedNode.ICON_DISPLAY] && openModal && parentScreen === "outbound") {
            handleNewField(false);
        }
        else if (parentScreen === "outbound"){
            setShowModal(true);
        }
        else if (['LOOP_ITEM', 'CONDITION_IF', 'CONDITION_ELSE'].includes(selectedNode.ICON_DISPLAY) && openModal && parentScreen === "workflow") {
            setShowModal(true);
        } else if (selectedNode.key === 'wf-0' && selectedNode.ICON_DISPLAY === 'OBJECTS' && parentScreen === "workflow") {
            handleNewField(true);
            return;
        } else {
            handleNewField(false);
            return;
        }
    }
    useEffect(() => {
        if (openModal) {
            newVariableHandler();
        }
    }, [openModal])

    return (
        <Dialog open={showModal} maxWidth="xs" fullWidth>
            <DialogTitle className="dialog-header">
                <div className="title">
                    {t("BOX_CONFIRM")}
                </div>
            </DialogTitle>
            <DialogContent className="dialog-content" dividers>
                <div>{content}</div>
            </DialogContent>
            <DialogActions>
                <Button size='small' variant="outlined" color="primary" onClick={() => handleNewField(true)} >
                    {t("BTN_YES")}
                </Button>
                <Button size='small' variant="outlined" color="primary" onClick={() => handleNewField(false)} >
                    {t("BTN_NO")}
                </Button>
                <Button size='small' variant="outlined" color="primary" onClick={() => {
                    toggle(null);
                    setShowModal(false);
                }} >
                    {t("BTN_CANCEL")}
                </Button>
            </DialogActions>
        </Dialog>
    )
};


export default NewVariable;


const getVariableName = (tree, isOutbound) => {
    const data = cloneDeep(tree);
    const body = data.body.translatedData;
    const header = data.header.translatedData;
    const trailer = data.trailer.translatedData;
    let titleNumber = -1; // Start from -1 to handle "VARIABLE" as (0)

    const getTitleName = (data) => {
        data.forEach((ele) => {
            if (
                ele?.ICON_DISPLAY === "VARIABLE_ITEM" &&
                ele?.NAME?.includes(t("VARIABLE")) // Use title, not NAME
            ) {
                let title = isOutbound
                    ? ele?.title?.replace(`${t("LBL_RECORD")} `, "")
                    : ele.title;

                const match = title.match(/\((\d+)\)$/); // Match numbers in parentheses
                const number = match ? parseInt(match[1], 10) : (title === t("VARIABLE") ? 0 : NaN);

                if (!isNaN(number)) {
                    titleNumber = Math.max(titleNumber, number);
                }
            }
            if (ele?.children?.length > 0) {
                getTitleName(ele.children);
            }
        });
    };

    getTitleName(body);
    getTitleName(header);
    getTitleName(trailer);

    return titleNumber === -1 ? t("VARIABLE") : `${t("VARIABLE")} (${titleNumber + 1})`;
};

